import { render, staticRenderFns } from "./DualColumnTextContent.vue?vue&type=template&id=4951c93e&scoped=true"
import script from "./DualColumnTextContent.vue?vue&type=script&lang=js"
export * from "./DualColumnTextContent.vue?vue&type=script&lang=js"
import style0 from "./DualColumnTextContent.vue?vue&type=style&index=0&id=4951c93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951c93e",
  null
  
)

export default component.exports